import { render, staticRenderFns } from "./ProfessionForm.vue?vue&type=template&id=0ab41c41&scoped=true"
import script from "./ProfessionForm.vue?vue&type=script&lang=js"
export * from "./ProfessionForm.vue?vue&type=script&lang=js"
import style0 from "./ProfessionForm.vue?vue&type=style&index=0&id=0ab41c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab41c41",
  null
  
)

export default component.exports